import './categoryArchiveComponent.scss';

import React, { useEffect, useState } from 'react';

import { GatsbyImage } from 'gatsby-plugin-image';
import { IMapObj } from '../../utils/getCategoryMap';
import { LocalizedLink } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';

export default function CategoryArchiveComponent(props: {
    title?: string;
    categoryNumber?: number;
    images: any[];
    captions: any[];
    category?: string;
    subCategory?: string;
    sortedAplhabetically?: boolean;
    ventingCategory?: string;
}) {
    const {
        title,
        images,
        captions,
        categoryNumber = captions.length,
        category,
        subCategory,
        sortedAplhabetically = true,
        ventingCategory,
    } = props;
    const { currentLocale } = usePageLocalization();

    const [displayedCaptions, setDisplayedCaptions] = useState(
        captions?.sort((a: any, b: any) => {
            if (a?.caption?.[currentLocale] < b?.caption?.[currentLocale])
                return -1;
            if (a?.caption?.[currentLocale] > b?.caption?.[currentLocale])
                return 1;
            return 0;
        })
    );

    return (
        <>
            {title && <h2 className='archive-title'>{title}</h2>}
            <div className='category-archive'>
                {displayedCaptions
                    ?.slice(0, categoryNumber)
                    ?.map((caption, index) => (
                        <CategoryArchiveSingle
                            key={`category-archive-elem-${index}`}
                            element={caption}
                            image={
                                images?.[caption.index]?.childImageSharp?.gatsbyImageData
                            }
                            index={index}
                            captions={captions}
                            category={category}
                            ventingCategory={ventingCategory}
                        />
                    ))}
            </div>
        </>
    );
}

function CategoryArchiveSingle(props: {
    element: IMapObj;
    image: any;
    index: number;
    captions: any[];
    category?: string;
    ventingCategory?: string;
}) {
    const { element, image, index, captions, category, ventingCategory } =
        props;
    const { currentLocale } = usePageLocalization();
    const { t } = useTranslation('layout');
    const captionText = captions?.[index]?.caption?.[currentLocale];

    function removeSpecialCharacters(str: string) {
        return str
            ?.toLowerCase()
            ?.replaceAll(', ', '-')
            ?.replaceAll(' ', '-')
            ?.replaceAll("'", '-')
            ?.replaceAll(',', '-')
            ?.replaceAll('ê', 'e')
            ?.replaceAll('é', 'e')
            ?.replaceAll('à', 'a');
    }

    const heatersLabel = t('categories.heaters');
    const ventingLabel = t('categories.venting');
    const accessoryLabel = t('categories.accessories');
    const categoryLinkFromCaption =
        removeSpecialCharacters(captionText) ?? '#captionMissing';

    let captionLink = '#';
    switch (category?.toLowerCase()) {
        case 'heaters':
            captionLink = `/${heatersLabel}/${categoryLinkFromCaption}/`;
            break;

        case 'venting':
            captionLink = ventingCategory
                ? `/${ventingLabel}/${ventingCategory}/${categoryLinkFromCaption}/`
                : `/${ventingLabel}/${categoryLinkFromCaption}/`;
            break;

        case 'accessories':
            captionLink = `/${accessoryLabel}/${categoryLinkFromCaption}/`;
            break;
    }

    return (
        <LocalizedLink className='archive-single' to={captionLink}>
            {image ? (
                <GatsbyImage image={image} alt='' className='img' />
            ) : (
                <div className='img' />
            )}

            <div className='single-title'>{captionText ?? element?.label}</div>
        </LocalizedLink>
    );
}
